import React from "react";
import classNames from "classnames";
import Anchor from "../Anchor";
import { AnchorElementTags } from "../Anchor/AnchorTypes";
import ArrowRightIcon from "@dcl/icons/esm/ui/arrow-right";
import PlusIcon from "@dcl/icons/esm/ui/plus";
import getClassNameFactory from "../../utilities/classNames";
import { LinkTypes } from "./LinkTypes";

var Link = function Link(_ref) {
  var block = _ref.block,
      children = _ref.children,
      contentLocation = _ref.contentLocation,
      download = _ref.download,
      href = _ref.href,
      iconLeft = _ref.iconLeft,
      iconRight = _ref.iconRight,
      modalLabel = _ref.modalLabel,
      newWindow = _ref.newWindow,
      type = _ref.type,
      innerRef = _ref.innerRef;
  var getClassName = getClassNameFactory(Link.displayName);
  var withIcon = iconLeft || iconRight || type !== "inline";
  /** TODO: no default case on switch as the instantiated variable remains untouched */

  var icon = iconRight || iconLeft;

  switch (type) {
    case LinkTypes.ACTION:
      icon = /*#__PURE__*/React.createElement(PlusIcon, null);
      break;

    case LinkTypes.PRIMARY:
    case LinkTypes.SECONDARY:
      icon = /*#__PURE__*/React.createElement(ArrowRightIcon, null);
      break;
  }

  var Wrapper = function Wrapper(props) {
    return /*#__PURE__*/React.createElement(Anchor, {
      className: getClassName({
        modifiers: classNames({
          block: block,
          iconLeft: iconLeft,
          withIcon: withIcon
        }, type)
      }),
      contentLocation: contentLocation,
      download: download,
      fallbackElementTag: AnchorElementTags.SPAN,
      href: href,
      innerRef: innerRef,
      modalLabel: modalLabel,
      newWindow: newWindow
    }, props.children);
  };

  if (withIcon) {
    return /*#__PURE__*/React.createElement(Wrapper, null, iconLeft && /*#__PURE__*/React.createElement("span", {
      className: getClassName({
        descendantName: "icon"
      })
    }, icon), /*#__PURE__*/React.createElement("span", {
      className: getClassName({
        descendantName: "inner"
      })
    }, children), !iconLeft && /*#__PURE__*/React.createElement("span", {
      className: getClassName({
        descendantName: "icon"
      })
    }, icon));
  } // Deliberately without descendants


  return /*#__PURE__*/React.createElement(Wrapper, null, children);
};

Link.defaultProps = {
  type: "inline"
};
Link.displayName = "Link";
Link.types = LinkTypes;
export default Link;